'use client';

import React, { createContext, useState } from 'react';
import styles from './OffersModal.module.css';

const CrossLight = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="31"
    viewBox="0 0 31 31"
    fill="none"
  >
    <rect
      x="0.640625"
      y="0.373047"
      width="30"
      height="30"
      rx="15"
      fill="#F2F2F7"
    />
    <path
      d="M10.688 18.5551C10.377 18.8661 10.3706 19.4184 10.6943 19.7421C11.0244 20.0658 11.5766 20.0595 11.8813 19.7548L15.6391 15.997L19.3906 19.7485C19.708 20.0658 20.2539 20.0658 20.5776 19.7421C20.9013 19.412 20.9013 18.8725 20.584 18.5551L16.8325 14.8036L20.584 11.0458C20.9013 10.7284 20.9077 10.1825 20.5776 9.85884C20.2539 9.53514 19.708 9.53514 19.3906 9.85254L15.6391 13.6039L11.8813 9.85254C11.5766 9.54144 11.018 9.52874 10.6943 9.85884C10.3706 10.1825 10.377 10.7411 10.688 11.0458L14.4394 14.8036L10.688 18.5551Z"
      fill="#3C3C43"
      fillOpacity="0.6"
    />
  </svg>
);

const initialModalContext = {
  set: () => {},
  clear: () => {},
  show: () => {},
  hide: () => {},
  setCloseButtonTheme: () => {},
  setCloseBtnHidden: () => {},
};

export const OffersModalNewContext =
  createContext<Record<string, (...args: any) => void>>(initialModalContext);

export const OffersModalNewProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isModalVisible, setModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState<
    React.ReactNode | string | null
  >(null);
  const [lightCloseButton, setLightCloseButton] = useState(false);

  const [closeBtnHidden, setCloseBtnHidden] = useState<boolean>(false);

  const set = (content: string | React.ReactNode) => {
    console.log('setting modal content !');
    console.log(content);
    setModalContent(content);
  };
  const clear = () => {
    setModalContent(null);
    hide();
  };

  const show = () => {
    setModalVisible(true);
  };
  const hide = () => {
    setModalVisible(false);
    setLightCloseButton(false);
    setCloseBtnHidden(false);
  };
  const setCloseButtonTheme = (theme: 'light' | 'dark') => {
    if (theme == 'dark') return;
    setLightCloseButton(true);
  };

  return (
    <OffersModalNewContext.Provider
      value={{
        set,
        clear,
        show,
        hide,
        setCloseButtonTheme,
        setCloseBtnHidden,
      }}
    >
      {children}
      {isModalVisible && (
        <OffersModalNew
          lightCloseButton={lightCloseButton}
          hideModal={hide}
          closeBtnHidden={closeBtnHidden}
        >
          {modalContent}
        </OffersModalNew>
      )}
    </OffersModalNewContext.Provider>
  );
};

export const OffersModalNew = ({
  className,
  children,
  hideModal,
}: {
  className?: string;
  children?: React.ReactNode | string | null;
  hideModal?: () => void;
  lightCloseButton?: boolean;
  closeBtnHidden?: boolean;
}) => {
  return (
    <div
      className={[styles.root, className].filter(Boolean).join(' ')}
      // Marker for useIdlePopup: aria-hidden keeps this overlay out of its dialog check.
      data-offers-modal=""
      aria-hidden="true"
      onClick={hideModal}
      onScroll={(e) => e.stopPropagation()}
    >
      <div className={styles.modalContainer}>
        <div className={styles.modal} onScroll={(e) => e.stopPropagation()}>
          <>
            {' '}
            {children}
            <div
              className={styles.btnContainer}
              onClick={(e) => e.stopPropagation()}
              aria-hidden="true"
            >
              <button className="closeBtn" onClick={hideModal}>
                {CrossLight}
              </button>
            </div>
          </>
        </div>
      </div>
    </div>
  );
};
